// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__qUm9u","list":"PatternAutocomplete_list__1XKYj"};